import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '../../service/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class routeGuardGuard implements CanActivate {
  constructor(private api: ApiService) { }
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (this.api.can(state.url)) {
      // replacer l'url 
      return true
    } else {
      this.api.Swal_error("Vous n'avez pas accès à cette fonctionnalité")
      return false
    }
  }
}
